import CompanyHelper from './models/CompanyHelper';

export default { companies: CompanyHelper };
